import {
	SERVER_SEND_MAIL_RESPONSE,
	SEND_MAIL_RESPONSE_SUCCESS,
	SET_MAIL_RESPONSE_DATA,
	GET_MAIL_RESPONSE_DATA_ERROR,
	SEND_MAIL_RESPONSE_ERROR,
	RESET_MAIL_RESPONSE_MODALS,
	ADD_MAIL_RESPONSE_MESSAGE
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	reportId: null,
	insertDate: null,
	address: {
		zip: null,
		city: null,
		street: null,
		houseNumber: null
	},
	supTypeName: null, // ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
	type: null,
	status: null,
	description: null,
	organisation: null,
	messages: [],
	loading: {
		getData: true,
		sendMessage: false
	},
	error: null,
	sendError: null,
	sendSuccess: false
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SERVER_SEND_MAIL_RESPONSE:
			return { ...state, loading: { ...state.loading, sendMessage: true } };
		case SEND_MAIL_RESPONSE_SUCCESS:
			return { ...state, loading: { ...state.loading, sendMessage: false }, sendSuccess: true };
		case SET_MAIL_RESPONSE_DATA:
			return {
				...state,
				organisation: action.payload.organisation,
				reportId: action.payload.reportId,
				insertDate: action.payload.insertDate,
				address: action.payload.address,
				type: action.payload.type,
				description: action.payload.description,
				status: action.payload.status,
				messages: action.payload.messages,
				supTypeName: action.payload.supTypeName, // ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
				loading: { ...state.loading, getData: false }
			};
		case GET_MAIL_RESPONSE_DATA_ERROR:
			return { ...state, error: action.payload.error, loading: { ...state.loading, getData: false } };
		case SEND_MAIL_RESPONSE_ERROR:
			return { ...state, sendError: action.payload.error, loading: { ...state.loading, sendMessage: false } };
		case RESET_MAIL_RESPONSE_MODALS:
			return { ...state, sendError: null, sendSuccess: false };
		case ADD_MAIL_RESPONSE_MESSAGE:
			return { ...state, messages: [...state.messages, action.payload.message] };
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/MailResponse.js